/**
 * Shared table styles for the Dashboard Users panel, extracted from
 * `DashboardUsersPanel.tsx` so the panel header, the user row, and the invite
 * row all reference one definition.
 */

/** Uppercase, muted column-header cell — the prior themed `<thead>` treatment. */
export const headCellSx = {
  py: 1,
  fontSize: 11,
  fontWeight: 500,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "text.disabled",
} as const;

/** Compact native <select> styled to match the theme — kept native so the
 * inline role picker stays dense inside the table cell (and labelled for a11y). */
export const rowSelectSx = {
  borderRadius: 1,
  border: 1,
  borderColor: "divider",
  bgcolor: "background.default",
  color: "text.primary",
  px: 1,
  py: 0.5,
  fontSize: 12,
  cursor: "pointer",
  "&:hover": { borderColor: "text.disabled" },
} as const;
